<template>
    <div :class="['hpImpRange',getPlatformClass,visible ? 'visible':'']">

        <!-- implant image -->
        <div :class="['implantContainer',isFadedout===true ? 'impFadedout' : '']">          
          <img class="itemImg" :src="selectedProductImg" />
          <div class="itemTitle">
              {{selectedProduct}}
          </div>          
        </div>

        <!-- Platform bar  -->
        <div :class="['platformBarCon',plaformIndex>-1 ? 'mounted':'mounted']">
          <platformbar 
            ref="pbar1"
            v-bind:affectOtherSections = "false"
            v-bind:sectionIndex = "2"
            skinMode = "light"
            @platform-change="onPlatformChange" 
            @item-change="onItemChange">
          </platformbar>
        </div>

    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines } from "@/utils";
import platformbar from "@/views/com/platformbar.vue";
import splitter from "@/views/com/splitter.vue";

export default 
{
    components:{platformbar,splitter},
    props: {
        visible:Boolean,
        sectionDataIndex:Number,
        isNavOpen: Boolean
    },
    data()
    {
        return {
            plaformIndex:-1,
            selectedProduct:'',
            selectedProductImg:'',
            itemx:[],
            isFadedout:true
        }
    },
    watch: {
      '$store.state.siteVisibleSection': function() {
        var vm=this;
        let _siteVisibleSection = this.$store.state.siteVisibleSection;
        if(_siteVisibleSection==2)
        {
          vm.$refs.pbar1.doSomething();
          //section is scrolled in
          //Select default platform (if not selected)
          //alert("select now");
        }
      }
    },

    methods:
    {
      //...mapActions(["xSetPlatform"]),
      onPlatformChange(plaformIndex)
      {
        this.plaformIndex = plaformIndex;
      },
      onItemChange(catalogNo)
      {
        var vm = this;        
        var APP_SITE_NAME = this.minisite_data.SITE_NAME;
        vm.isFadedout = true;        
        setTimeout(() => {
          //load the product image and description 
          //change bg color according to the platform
          vm.selectedProduct = catalogNo;
          //vm.selectedProductImg = "content/"+APP_SITE_NAME+"/img/implants/"+catalogNo+".png";
          vm.selectedProductImg = "https://www.mis-implants.com/upload/catalog/products/thumbs/"+catalogNo.trim()+".png";
        }, 500);

        setTimeout(() => {
          vm.isFadedout = false;
        }, 900);

      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["xSelectedPlatform","minisite_data"]),
        getPlatformClass()
        {
          //We can finally animate CSS gradient:
          //https://dev.to/afif/we-can-finally-animate-css-gradient-kdk
          return this.plaformIndex>-1 ? "platform_"+this.plaformIndex: '';
        },
        sectionData(){
            return this.minisite_data.SECTIONS[this.sectionDataIndex];
        }

    }
};

</script>






<style lang="css" scoped>
    @property --c {
      syntax: '<color>';
      inherits: false;
      initial-value: red;
    }
    .hpImpRange.visible
    {
      display: block;
    }
    .hpImpRange
    {      
      display: block;
      background: transparent;
        /* position:relative; */
        width: 100%;
        height: 100%;   
        position: relative;     
        /* z-index: 100; */
/*         display: grid;
        align-items: center;
 */        display: block;

      /* //var(--dark-blue);         needed for firefox to have a valid output */
      /*
        --c:var(--dark-blue); 
        transition:--c 0.6s;
        background: radial-gradient(circle, var(--c) 0%,var(--dark-blue) 50%);
        */
    }
    
    .hpImpRange.platform_0{--c:#2a2512;}
    .hpImpRange.platform_1{--c:#241128;}
    .hpImpRange.platform_2{--c:#241128;}
    .hpImpRange.platform_3{--c:#0f250e;}

    .hpImpRange .container
    {
      width: 100vw;
    }
    .hpImpRange .title
    {
        font-size: 18px !important;
        font-weight: 100 !important;
        font-weight: 400 !important;        
        letter-spacing: -0.5px;
        color: var(--text-blue);
        text-align:left;        

        position:absolute;
        top:0px;left: 0px;
        padding-left: max(180px, 10vw);
        top:100px;
        
    }
    .hpImpRange .SelectPlatform
    {
      top:calc(50% - 70px);
      transform: translateY(-50%);
      color:#202020;
      width: 100%;
      text-align: center;
      position: absolute;
      font-size: 16px;
      font-weight: 300;
    }
    .hpImpRange .platformBarCon
    {
      transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      position: absolute;
      bottom: 30px;
      /* transform: translateY(-50%); */
      width: 100%;
    }
    .hpImpRange .platformBarCon.mounted
    {
      /* top:calc(100vh - 120px); */
      bottom: 30px;
    }    
    .implantContainer
    {
      position: absolute;
      top:calc(50% - 100px);
      transform: translateY(-50%);
      width: 100%;text-align: center;
      color:#fff;
      pointer-events: none;
      opacity: 1;
      transition: all ease 0.4s;
    }
    .implantContainer.impFadedout
    {
      opacity: 0;
    }
    .implantContainer .itemImg
    {
      height: 36vh;width:auto;
    }
    .implantContainer .itemTitle
    {
      padding-top: 20px;
      font-size: 14px;color: #202020;
      font-weight: 300;text-align: center;
    }

  @media (hover: hover) {
  }
</style>